import { useState, useEffect } from 'react';
import { 
  isNativePlatform, 
  takePhoto, 
  pickImage, 
  getCurrentPosition, 
  hapticImpact,
  hapticNotification,
  shareContent 
} from '@/utils/capacitor';
import { toast } from 'sonner';

export const useNativeFeatures = () => {
  const [isNative, setIsNative] = useState(false);
  const [location, setLocation] = useState<{ latitude: number; longitude: number } | null>(null);

  useEffect(() => {
    setIsNative(isNativePlatform());
  }, []);

  const capturePhoto = async () => {
    try {
      const photo = await takePhoto();
      if (photo) {
        await hapticNotification('success');
        return photo;
      }
      return null;
    } catch (error) {
      toast.error('Failed to capture photo');
      await hapticNotification('error');
      return null;
    }
  };

  const selectImage = async () => {
    try {
      const image = await pickImage();
      if (image) {
        await hapticNotification('success');
        return image;
      }
      return null;
    } catch (error) {
      toast.error('Failed to select image');
      await hapticNotification('error');
      return null;
    }
  };

  const getLocation = async () => {
    try {
      const position = await getCurrentPosition();
      setLocation(position);
      await hapticNotification('success');
      return position;
    } catch (error) {
      toast.error('Failed to get location');
      await hapticNotification('error');
      return null;
    }
  };

  const triggerHaptic = async (type: 'light' | 'medium' | 'heavy' = 'medium') => {
    if (isNative) {
      await hapticImpact(type);
    }
  };

  const share = async (title: string, text: string, url?: string) => {
    try {
      await shareContent(title, text, url);
      await hapticNotification('success');
    } catch (error) {
      toast.error('Failed to share');
      await hapticNotification('error');
    }
  };

  return {
    isNative,
    location,
    capturePhoto,
    selectImage,
    getLocation,
    triggerHaptic,
    share
  };
};